module.exports = __webpack_public_path__ + "sounds/exclamation-mark-0de31ffaf38760c13a454c18ee59f549.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/exclamation-mark.mp3
// module id = 16
// module chunks = 0